import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

export function Toggle({ label, setChecked, isChecked, name }) {
  return (
    <Container>
      <Switch>
        <input
          type="checkbox"
          onChange={setChecked}
          checked={isChecked ? 'checked' : ''}
          name={name}
        />
        <Slider className="slider" />
      </Switch>
      {label ? <p>{label}</p> : null}
    </Container>
  );
}

const Container = styled.div`
  font-family: sans-serif;
  display: flex;
  align-items: center;

  p {
    margin-left: 20px;
  }
`;

const Switch = styled.label`
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;

  input {
    opacity: 0;
    width: 0;
    height: 0;

    &:checked + .slider {
      background-color: var(--theme-secondary-color);

      &:before {
        transform: translateX(26px);
      }
    }

    &:focus + .slider {
      box-shadow: 0 0 1px var(--theme-secondary-color);
    }
  }
`;

const Slider = styled.span`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
  border-radius: 34px;

  &::before {
    position: absolute;
    content: '';
    height: 26px;
    width: 26px;
    left: 4px;
    bottom: 4px;
    border-radius: 50%;
    background-color: var(--theme-primary-color);
    transition: 0.4s;
  }
`;
